import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faFacebook, faYoutube, faWhatsapp, faTiktok } from "@fortawesome/free-brands-svg-icons";

// Social media links data (matching header)
const socials = [
  {
    icon: faInstagram,
    url: "https://instagram.com/annyeongaisyasyalc",
    name: "Instagram",
  },
  {
    icon: faTiktok,
    url: "https://www.tiktok.com/@annyeongaisyasya",
    name: "TikTok",
  },
  {
    icon: faFacebook,
    url: "https://www.facebook.com/profile.php?id=61555662309762&mibextid=2JQ9oc",
    name: "Facebook",
  },
  {
    icon: faYoutube,
    url: "https://www.youtube.com/@AnnyeongAisyasya",
    name: "YouTube",
  },
  {
    icon: faWhatsapp,
    url: "https://wa.me/60145893016",
    name: "WhatsApp",
  },
];

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <img 
            src={process.env.PUBLIC_URL + '/assets/logos/logo.jpg'} 
            alt="Annyeong Aisyasya Logo" 
            className="footer-logo" 
          />
          <p>Your Korean learning family<br />where dreams become reality! 💜<br />안녕하세요 together!</p>
        </div>
          <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/about">About Us</a></li>
            <li><a href="/courses">Courses</a></li>
            <li><a href="/faq">FAQ</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>        <div className="footer-section">
          <h4>Connect With Us</h4>
          <div className="social-links">
            {socials.map((social, index) => (
              <a
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.name}
                className="social-link"
              >
                <FontAwesomeIcon icon={social.icon} className="social-icon" />
                <span className="social-name">{social.name}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
        <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Annyeong Aisyasya. All rights reserved.</p>
        <ul className="footer-links-list">
          <li className="policy-link"><a href="/privacy-policy">Privacy Policy</a></li>
          <li className="policy-link"><a href="/terms-conditions">Terms & Conditions</a></li>
        </ul>
        <p className="designer-credit">
          Website designed by <a href="https://alwialhaddad.com" rel="noopener noreferrer">Alwi Al-haddad</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;